<div class="contract-card flex flex-col gap-4">
  <!-- Fila superior: título (izquierda) + fecha inicio (derecha) -->
  <div class="flex items-start justify-between gap-4">
    <h3 class="contract-title">{{ name() | translate }}</h3>
    <div class="date shrink-0 text-right">
      <span class="date-label">{{
        "accountManagement.dialog.contracts.startDate" | translate
      }}</span>
      @if (startDate(); as sd) {
        <span class="date-value ml-2">{{ formatDate(sd) }}</span>
      }
    </div>
  </div>

  <!-- Fila inferior: botones de acción (izquierda) + baja (derecha) -->
  <div class="flex items-center justify-between gap-3 flex-wrap">
    <div class="flex flex-wrap gap-3">
      <p-button
        icon="pi pi-download"
        size="small"
        [label]="'accountManagement.dialog.contracts.requestSigned' | translate"
        [loading]="loadingRequestSigned()"
        (click)="onRequestSigned()"
      ></p-button>
      @if (showCertificateButton()) {
        <p-button
          severity="secondary"
          size="small"
          [label]="
            'accountManagement.dialog.contracts.requestCertificate' | translate
          "
          [loading]="loadingRequestCertificate()"
          (click)="onRequestCertificate()"
        ></p-button>
      }
    </div>
    @if (showDeactivateButton()) {
      <p-button
        severity="danger"
        size="small"
        text
        [label]="'accountManagement.dialog.contracts.deactivate' | translate"
        [loading]="loadingDeactivate()"
        (click)="onDeactivate()"
      ></p-button>
    }
  </div>
</div>
